import styled, { css } from "styled-components";

interface ButtonStyle {
  $bg: string;
  $color: string;
  $bgHover: string;
  $padding: string;
  $borderRadius: string;
  $outlined: boolean;
  $height: string;
}

export const baseButtonStyles = css<ButtonStyle>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-style: normal;
  min-width: 80px;
  color: ${(p) =>
    p.$outlined ? p.theme.colors.button.primary.background : p.$color};
  background-color: ${(p) => (p.$outlined ? "transparent" : p.$bg)};
  transition: all 0.15s ease-in-out;
  box-sizing: border-box;
  padding: ${(p) => p.$padding};
  border-radius: ${(p) => p.$borderRadius};
  height: ${(p) => p.$height};
  position: relative;

  ${(p) =>
    p.$outlined
      ? `border: 1px solid ${
          p.theme.colors.button.primary.background ?? p.$bg
        };`
      : undefined}

  &:hover:not([disabled]) {
    cursor: pointer;
    background: ${(p) =>
      p.$outlined ? p.theme.colors.button.primary.background : p.$bgHover};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const LinkElement = styled.a<ButtonStyle>`
  ${baseButtonStyles};
`;

export const ButtonElement = styled.button<ButtonStyle>`
  ${baseButtonStyles};
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);
`;

export const ButtonText = styled.span<{ size: string; color: string }>`
  font-size: ${({ size }) => size};
  color: ${({ color }) => color};
  font-weight: 400;
`;
